import React from "react";

interface LoadingPageProps {
  title?: string;
}

const LoadingPage: React.FC<LoadingPageProps> = ({ title = "Loading..." }) => {
  return (
    <div
      role="status"
      aria-live="polite"
      className="z-10 h-full w-full place-content-center"
    >
      <div className="mx-auto mt-80 object-center w-16 h-16 flex items-center justify-center">
        <span className="icon-sync animate-spin text-blue-600 text-5xl" />
      </div>
      <div className="pt-4 text-lg text-center font-medium text-gray-700">
        {title}
      </div>
    </div>
  );
};

export default LoadingPage;
